/*
 * @Author: Claude
 * @Date: 2025-11-15
 * @Description: 获取图片尺寸工具函数
 */

/**
 * 图片尺寸信息
 */
export interface ImageDimensions {
  /** 宽度（像素） */
  width: number;
  /** 高度（像素） */
  height: number;
}

/**
 * 获取图片尺寸
 * @param file - 图片文件
 * @returns Promise<ImageDimensions> - 图片宽高信息
 */
export const getImageDimensions = (file: File): Promise<ImageDimensions> => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('file is not a image'));
      return;
    }

    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({
        width: img.width,
        height: img.height,
      });
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('load image failed'));
    };

    img.src = url;
  });
};
